<template>
  <w-map-element-tree ref="tree" :elementType="MapConst.ELEMENT_TYPE.CUSTOM"></w-map-element-tree>
</template>

<script>
import MapConst from '@/constants/topologymap';
import WMapElementTree from '@/views/topologymap/components/MapElementTree';

export default {
  name: 'WCustomObjectElement',
  components: {
    WMapElementTree,
  },
  data() {
    return {
      MapConst,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/element/CustomObjectElement.vue